/* ENTiNA navigation — desktop mega menu + mobile plain accordion. */
(() => {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const detailsSelector = '.entina-navigation--desktop details[data-entina-menu]';
  const mobileToggleSelector = '.js-entina-mobile-navigation [data-entina-mobile-toggle]';
  const scrollCloseThreshold = 56;

  function setExpanded(details, open) {
    details.open = open;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
    if (open) details.dataset.entinaScrollOrigin = String(window.scrollY);
    else delete details.dataset.entinaScrollOrigin;
  }

  function closeAllDesktop(except = null) {
    document.querySelectorAll(detailsSelector).forEach((details) => {
      if (details !== except) setExpanded(details, false);
    });
  }

  function activateCategory(button) {
    const mega = button.closest('.entina-navigation__mega');
    if (!mega) return;
    const index = button.dataset.entinaCategory;
    mega.querySelectorAll('[data-entina-category]').forEach((candidate) => {
      const active = candidate === button;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-selected', String(active));
    });
    mega.querySelectorAll('[data-entina-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.entinaPanel === index);
    });
  }

  function bindDesktopNavigation() {
    document.querySelectorAll('.entina-navigation--desktop [data-entina-category]').forEach((category) => {
      if (category.dataset.entinaCategoryBound === 'true') return;
      category.dataset.entinaCategoryBound = 'true';
      category.addEventListener('pointerenter', () => {
        if (desktopQuery.matches) activateCategory(category);
      });
      category.addEventListener('focus', () => {
        if (desktopQuery.matches) activateCategory(category);
      });
    });
  }

  function setMobileToggle(toggle, open) {
    const submenu = toggle.nextElementSibling;
    if (!submenu || !submenu.matches('[data-entina-mobile-submenu]')) return;
    toggle.setAttribute('aria-expanded', String(open));
    submenu.hidden = !open;
  }

  function closeMobileSiblings(toggle) {
    const item = toggle.parentElement;
    const list = item?.parentElement;
    if (!list) return;
    Array.from(list.children).forEach((sibling) => {
      if (sibling === item) return;
      const siblingToggle = sibling.querySelector(':scope > [data-entina-mobile-toggle]');
      if (siblingToggle) setMobileToggle(siblingToggle, false);
    });
  }

  document.addEventListener('click', (event) => {
    const mobileToggle = event.target.closest(mobileToggleSelector);
    if (mobileToggle) {
      event.preventDefault();
      event.stopPropagation();
      const open = mobileToggle.getAttribute('aria-expanded') === 'true';
      closeMobileSiblings(mobileToggle);
      setMobileToggle(mobileToggle, !open);
      return;
    }

    const category = event.target.closest('.entina-navigation--desktop [data-entina-category]');
    if (category && desktopQuery.matches) {
      event.preventDefault();
      activateCategory(category);
      return;
    }

    const desktopLink = event.target.closest(`${detailsSelector} a`);
    if (desktopLink) {
      closeAllDesktop();
      return;
    }

    const summary = event.target.closest(`${detailsSelector} > summary`);
    if (summary && desktopQuery.matches) {
      event.preventDefault();
      const details = summary.parentElement;
      const nextState = !details.open;
      closeAllDesktop(nextState ? details : null);
      setExpanded(details, nextState);
      return;
    }

    if (!event.target.closest('.entina-navigation--desktop')) closeAllDesktop();
  });

  window.addEventListener('scroll', () => {
    if (!desktopQuery.matches) return;
    const openDetails = document.querySelector(`${detailsSelector}[open]`);
    if (!openDetails) return;
    const origin = Number(openDetails.dataset.entinaScrollOrigin);
    if (Number.isFinite(origin) && Math.abs(window.scrollY - origin) >= scrollCloseThreshold) {
      setExpanded(openDetails, false);
    }
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    if (!event.target.closest('.entina-navigation--desktop')) closeAllDesktop();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const mobileNav = event.target.closest('.js-entina-mobile-navigation');
    if (mobileNav) {
      const openToggle = mobileNav.querySelector('[data-entina-mobile-toggle][aria-expanded="true"]');
      if (openToggle) {
        setMobileToggle(openToggle, false);
        openToggle.focus();
        return;
      }
    }

    const openDetails = document.querySelector(`${detailsSelector}[open]`);
    if (!openDetails) return;
    setExpanded(openDetails, false);
    openDetails.querySelector(':scope > summary')?.focus();
  });

  function init() {
    bindDesktopNavigation();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
